const translations = {
  "en": {
    "Add Transaction": "Add Transaction",
    "for more insights.": "for more insights."
  },
  "zh-tw": {
    "Add Transaction": "新增交易紀錄",
    "for more insights.": "解鎖更多洞察。"
  }
};

export default translations;
